import type { BannerSegment, BannerSegmentType, SegmentTestOption } from '@/api/banners';

/**
 * "Кому показывать" — в Orchid это называлось «сегменты» (таблица
 * banners_segments), но слово ничего не говорило пользователю: по сути это
 * правила, при которых баннер увидят. Типы 1:1 из BannerSegment:
 *  - all    — всем пользователям;
 *  - test   — тем, кто работает с выбранным тестом (data = MaintestName);
 *  - active — тем, кто был активен в заданный период.
 */
export const AUDIENCE_LABEL: Record<BannerSegmentType, string> = {
  all: 'Все пользователи',
  test: 'Работающие с тестом',
  active: 'Активные в период',
};

/**
 * Короткое человекочитаемое описание правила — для раскрытой плитки баннера.
 * Название теста берём из dataLabel (сервер уже резолвит код в TestTitle);
 * список tests — запасной путь, если метки в ответе почему-то нет.
 */
export function describeSegment(segment: BannerSegment, tests?: SegmentTestOption[]): string {
  if (segment.type === 'all') return AUDIENCE_LABEL.all;
  if (segment.type === 'test') {
    const label =
      segment.dataLabel ?? tests?.find((t) => t.value === segment.data)?.label ?? segment.data ?? '—';
    return `${AUDIENCE_LABEL.test}: ${label}`;
  }
  const from = segment.dateFrom ? formatDate(segment.dateFrom) : '…';
  const to = segment.dateTo ? formatDate(segment.dateTo) : '…';
  return `${AUDIENCE_LABEL.active}: ${from} — ${to}`;
}

function formatDate(value: string): string {
  const [year, month, day] = value.split('-');
  return `${day}.${month}.${year}`;
}
